import type { SessionValue } from "@/auth/session";

/** Thrown from a route's beforeLoad; the router renders it as a 403 page at the same URL. */
export class ForbiddenError extends Error {
  constructor(readonly missing: string[]) {
    super(`Missing permission: ${missing.join(", ")}`);
    this.name = "ForbiddenError";
  }
}

export function requirePermissions(session: Pick<SessionValue, "can">, permissions: readonly string[]) {
  const missing = permissions.filter((permission) => !session.can(permission));
  if (missing.length > 0) throw new ForbiddenError(missing);
}

// Only same-app paths. Resolving the target as the browser would catches "//x", "/\x" and
// control-character tricks like "/\t/x", which a string check misses.
export function safeRedirect(target: unknown): string {
  if (typeof target !== "string" || !target.startsWith("/")) return "/";
  try {
    const url = new URL(target, window.location.origin);
    if (url.origin !== window.location.origin) return "/";
    return url.pathname + url.search + url.hash;
  } catch {
    return "/";
  }
}
